export default __webpack_public_path__ + "static/media/Consultaion.2e3e99f4.svg";